/* Product sliders sent as shells (sections/am-product-slider, 15.10.2026). Their cards are fetched in one request per
   five sliders through the Section Rendering API (there section.index is empty, so the section renders in full) at the
   visitor's first scroll, tap, key, wheel or mouse move, or when a shell comes within 600px of the screen. The cards
   replace the empty frames inside the slider that amor.js has already set up; a 1px width nudge lets its
   ResizeObserver measure the real cards. Cards need nothing else: amor-cards.js, the swatches and Clarity listen on
   the document. If a request fails, the frames stay (banner, heading and "Zobacz wszystkie" still lead to the
   collection) and the shell is tried again when it comes near the screen. */
(() => {
  if (window.amRailsLazy) return;
  window.amRailsLazy = true;
  const run = () => {
    const shells = [...document.querySelectorAll('[data-am-lazy-rail]')];
    if (!shells.length) return;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    let busy = false, tries = 0;
    const fill = () => {
      const todo = shells.filter((s) => s.hasAttribute('data-am-lazy-rail'));
      if (busy || !todo.length) return;
      busy = true;
      const ids = todo.map((s) => s.dataset.amLazyRail);
      const parts = [];
      for (let i = 0; i < ids.length; i += 5) parts.push(ids.slice(i, i + 5));
      Promise.all(parts.map((part) => fetch(root + '?sections=' + part.join(','), { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.json() : {}))
        .then((map) => part.forEach((id) => {
          const box = todo.find((s) => s.dataset.amLazyRail === id);
          const html = map && map[id];
          if (!box || !html) return;
          const src = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-am-slider] .am-slider');
          const track = box.querySelector('.am-slider');
          if (!src || !track || src.classList.contains('am-slider--shell')) return;
          track.replaceChildren(...src.children);
          track.classList.remove('am-slider--shell');
          box.removeAttribute('data-am-lazy-rail');
          track.style.width = 'calc(100% - 1px)';
          requestAnimationFrame(() => { track.style.width = ''; });
        }))
        .catch(() => {})))
        .then(() => {
          busy = false;
          if (io && ++tries < 3) shells.forEach((s) => { if (s.hasAttribute('data-am-lazy-rail')) io.observe(s); });
        });
    };
    const evs = ['scroll', 'pointerdown', 'keydown', 'touchstart', 'wheel', 'mousemove'];
    const go = () => { evs.forEach((t) => removeEventListener(t, go, true)); fill(); };
    evs.forEach((t) => addEventListener(t, go, { passive: true, capture: true }));
    const io = 'IntersectionObserver' in window
      ? new IntersectionObserver((rows) => {
        rows.forEach((r) => { if (r.isIntersecting) io.unobserve(r.target); });
        if (rows.some((r) => r.isIntersecting)) fill();
      }, { rootMargin: '600px 0px' })
      : null;
    if (io) shells.forEach((s) => io.observe(s));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();